<template>
    <div class="LanguagePicker">
        <label class="LanguagePicker__label" for="LanguagePicker__select" data-wg-notranslate>{{ label }}</label>
        <select
            id="LanguagePicker__select"
            class="LanguagePicker__select"
            data-wg-notranslate
            :value="selected"
            @change="onChange"
        >
            <option v-for="language of languages" :key="language.tag || 'en'" :value="language.tag || ''">
                {{ language.name }}
            </option>
        </select>
    </div>
</template>
<style lang="less">
    .LanguagePicker {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 5px;

        &__label {
            color: #2d3e50;
            font-size: 0.9em;
            font-weight: bold;
            text-transform: uppercase;
            margin-right: 10px;
        }

        &__select {
            color: #2d3e50;
            font-size: 0.9em;
            padding: 2px 4px;
            border: 1px solid #2d3e50;
            border-radius: 3px;
            background: transparent;
        }
    }
</style>

<script lang="ts">
    import { Component, Vue } from 'vue-property-decorator';

    import { SUPPORTED_LANGUAGES } from '@/config/languages';
    import { switchWeglotLanguage } from '@/services/weglot';
    import { createSessionLanguageStore } from '@/services/weglotLanguageStore';

    /**
     * Lets someone read the interview in another language.
     *
     * Only rendered for relying parties enabled for localization, so the control never
     * appears where no translation is available. Its own text carries
     * `data-wg-notranslate` so the language names stay readable whatever the page is
     * translated into.
     */
    @Component
    export default class LanguagePicker extends Vue {
        private languages = SUPPORTED_LANGUAGES;
        private selected: string = '';

        // Shown in English, since someone who cannot read the page still has to find this.
        private label: string = 'Language';

        private created() {
            this.selected = createSessionLanguageStore().read() || '';
        }

        private async onChange(event: Event) {
            const tag = (event.target as HTMLSelectElement).value;
            this.selected = tag;
            await switchWeglotLanguage(tag || null);
            this.updateLangQuery(tag);
        }

        /** Keeps the language in the address bar, so a refresh stays in it. */
        private updateLangQuery(tag: string) {
            const query = { ...this.$route.query, lang: tag || 'en' };
            this.$router.replace({ path: this.$route.path, query, hash: this.$route.hash });
        }
    }
</script>
